import { render, staticRenderFns } from "./PpiRekapSurveilansPage.vue?vue&type=template&id=4aabb4a8&"
import script from "./PpiRekapSurveilansPage.vue?vue&type=script&lang=ts&"
export * from "./PpiRekapSurveilansPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports